import { render, staticRenderFns } from "./VModalRemarkRejectionChange.vue?vue&type=template&id=42b472f6&"
import script from "./VModalRemarkRejectionChange.vue?vue&type=script&lang=ts&"
export * from "./VModalRemarkRejectionChange.vue?vue&type=script&lang=ts&"
import style0 from "./VModalRemarkRejectionChange.vue?vue&type=style&index=0&id=42b472f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports